import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const QuickAddButton = ({ onAddIncome, onAddExpense }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="fixed bottom-8 right-8 z-50">
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 20 }}
                        className="absolute bottom-20 right-0 flex flex-col gap-3"
                    >
                        <button
                            onClick={() => {
                                onAddIncome();
                                setIsOpen(false);
                            }}
                            className="bg-emerald-500 hover:bg-emerald-600 text-white px-6 py-3 rounded-full shadow-lg font-medium transition-all duration-200 hover:shadow-xl whitespace-nowrap"
                        >
                            + Add Income
                        </button>
                        <button
                            onClick={() => {
                                onAddExpense();
                                setIsOpen(false);
                            }}
                            className="bg-rose-500 hover:bg-rose-600 text-white px-6 py-3 rounded-full shadow-lg font-medium transition-all duration-200 hover:shadow-xl whitespace-nowrap"
                        >
                            + Add Expense
                        </button>
                    </motion.div>
                )}
            </AnimatePresence>

            <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setIsOpen(!isOpen)}
                className="w-16 h-16 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full shadow-2xl flex items-center justify-center transition-colors duration-200"
            >
                {isOpen ? <X size={28} /> : <Plus size={28} />}
            </motion.button>
        </div>
    );
};

export default QuickAddButton;
